<template>
  <div id="myTasks">
    <div class="table-section">
      <el-card class="box-card" shadow="never">
        <el-form
          :inline="true"
          :model="searchParams"
          class="demo-form-inline"
          
        >
          <el-form-item label="业务类型">
            <el-select
              v-model.trim="searchParams.businessType"
              placeholder="业务类型"
            >
              <el-option
                v-for="item in businessTypeList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="产品">
            <el-select v-model.trim="searchParams.product" placeholder="产品">
              <el-option
                v-for="item in productList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="合同编号">
            <el-input
              v-model.trim="searchParams.contractNumber"
              placeholder="合同编号"
            />
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input
              v-model.trim="searchParams.borrowerName"
              placeholder="客户姓名"
            />
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input
              v-model.trim="searchParams.borrowerPhone"
              placeholder="手机号码"
            />
          </el-form-item>
          <el-form-item label="身份证号码">
            <el-input
              v-model.trim="searchParams.idNumber"
              placeholder="身份证号码"
            />
          </el-form-item>
          <el-form-item label="逾期天数">
            <el-input
              v-model.trim="searchParams.overdueDays"
              placeholder="逾期天数"
            >
              <template slot="append">天</template>
            </el-input>
          </el-form-item>
          <el-form-item label="最早逾期账期">
            <el-date-picker
              v-model="searchParams.fenAn"
              value-format="yyyy-MM-dd"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="fenAnChange"
            />
          </el-form-item>
          <el-form-item label="队列">
            <el-select
              v-model.trim="searchParams.workQueueId"
              placeholder="队列"
            >
              <el-option
                v-for="item in workQueueNameList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="处理人">
            <el-autocomplete
              v-model="operator"
              :fetch-suggestions="querySearch"
              placeholder="请输入处理人"
              @select="handleSelect"
              @change="operatorChange"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="状态" v-if="!$route.query.status">
            <el-select v-model.trim="taskStatus" placeholder="状态">
              <el-option
                v-for="item in taskStatusList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="联系状态">
            <el-select v-model.trim="contactStatusCode" placeholder="联系状态">
              <el-option
                v-for="item in contactStatusList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="机构">
            <el-select v-model.trim="orgCode" placeholder="机构">
              <el-option
                v-for="item in orgList"
                :key="item.org_code"
                :value="item.org_code"
                :label="item.orgName"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="" @click="clear">清空</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div class="table-section">
      <el-table
        :data="myTaskList.records"
        :header-row-style="headerRowStyle"
        max-height="550px"
        border
        highlight-current-row
        style="width: 100%"
        @cell-dblclick="dblclick"
      >
        <el-table-column prop="businessType" label="业务类型" width="80">
          <template slot-scope="scope">
            {{
              scope.row.businessType === "1"
                ? "爱分担"
                : scope.row.businessType === "2"
                ? "分担宝"
                : scope.row.businessType === "3"
                ? "助贷通道"
                : scope.row.businessType === "4"
                ? "好易付"
                : scope.row.businessType === "5"
                ? "实物租赁"
                : scope.row.businessType === "6"
                ? "乐享付"
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="productTypeName" label="产品" width="80" />
        <el-table-column prop="contractNumber" label="合同编号" width="300" />
        <el-table-column prop="borrowerName" label="客户姓名" width="80" />
        <el-table-column prop="borrowerPhone" label="客户手机号码" />
        <el-table-column prop="overdueDate" label="最早逾期账期" />
        <el-table-column prop="overdueDays" label="逾期天数" width="80" />
        <el-table-column prop="overdueCount" label="逾期期数" width="80" />
        <el-table-column prop="overdueAmount" label="逾期金额" width="90" />
        <el-table-column prop="taskStatus" label="案件状态" width="100" />
        <el-table-column prop="contactStatusValue" label="联系状态" width="80" />
        <el-table-column prop="lastedReminderResult" label="最新催记内容" />
        <el-table-column prop="lastCallTime" label="最近跟进时间" />
        <el-table-column prop="lastCallAgent" label="处理人" width="130" />
      </el-table>
    </div>
    <div class="pagination-section">
      <el-pagination
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        :total="myTaskList.total"
        layout="total, prev, pager, next, sizes"
        @current-change="changePage"
        @size-change="sizeChange"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getWorkQueueList, getDictionaryList, getafdOrg } from "@/api/task";
import { getUser } from "@/api/manage";

export default {
  name: "myTasks",
  data() {
    return {
      headerRowStyle: {
        "background-color": "#6584b4",
      },
      searchParams: {
        fenAn: "",
      },
      pageSize: 10,
      page: 1,
      workQueueNameList: [],
      businessTypeList: [],
      productList: [],
      orgList: [],
      operatorList: [],
      operator: "",
      taskStatusList: [],
      taskStatus: "",
      contactStatusList: [],
      contactStatusCode: "",
      orgCode: ''
    };
  },
  computed: {
    ...mapGetters(["currentUser", "myTaskList"]),
  },
  watch: {
    $route() {
      this.clear();
      this.loadTasks();
    },
  },
  async created() {
    getafdOrg().then(res => {
      this.orgList = res.data
    })
    this.loadTasks();
    const getWorkQueueListRes = await getWorkQueueList();
    getWorkQueueListRes.data.map((item) => {
      this.workQueueNameList.push({
        label: item.name,
        value: item.id,
      });
    });
    console.log(getWorkQueueListRes.data);
    const fdBusinessTypeRes = await getDictionaryList("fd_business_type");
    fdBusinessTypeRes.data.map((item) => {
      this.businessTypeList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    const profuctRes = await getDictionaryList("product_type");
    profuctRes.data.map((item) => {
      this.productList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    // 状态
    const taskStatusRes = await getDictionaryList("task_status");
    taskStatusRes.data.map((item) => {
      this.taskStatusList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    // 联系状态
    const contactStatusCodeData = await getDictionaryList('contact_status')
    contactStatusCodeData.data.map((item) => {
      this.contactStatusList.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
  },
  methods: {
    ...mapActions(["fetchMyTasks"]),
    loadTasks(flag) {
      this.searchParams.userId = this.currentUser.id;
      this.searchParams = Object.assign(this.searchParams, this.$route.query);
      if (this.taskStatus) {
        this.searchParams.status = this.taskStatus;
      }
      if (this.contactStatusCode) {
        this.searchParams.contactStatusCode = this.contactStatusCode;
      }
      if (this.orgCode) {
        this.searchParams.orgCode = this.orgCode;
      }

      this.fetchMyTasks({
        searchParams: this.searchParams,
        page: this.page,
        size: this.pageSize,
      });
    },
    changePage(currentPage) {
      this.page = currentPage;
      this.loadTasks();
    },
    search() {
      this.page = 1;
      this.loadTasks();
    },
    clear() {
      this.searchParams = {};
      this.operator = "";
      this.taskStatus = "";
      this.contactStatusCode = "";
      this.orgCode="";
      this.loadTasks();
    },
    sizeChange(size) {
      this.page = 1;
      this.pageSize = size;
      this.loadTasks();
    },
    // 双击
    dblclick(row, column) {
      // this.$router.push({
      //   name: "taskDetail",
      //   params: { loanId: row.loanId, taskId: row.id, ...this.$route.query },
      // });
      sessionStorage.setItem('borrowerName', row.borrowerName)
      window.open(`/#/task/${row.id}/${row.loanId}/${this.$route.query.status}?${ this.getSearchParamsQueryString() }`, '_blank')
    },
    fenAnChange(val) {
      if (val && val.length) {
        this.searchParams.overdueStartDay = val[0];
        this.searchParams.overdueEndDay = val[1];
      } else {
        this.searchParams.overdueStartDay = "";
        this.searchParams.overdueEndDay = "";
      }
    },
    async querySearch(queryString, cb) {
      const results = [];
      if (queryString) {
        const getUserRes = await getUser(queryString);
        if (getUserRes.data.length > 0) {
          getUserRes.data.map((item) => {
            results.push({
              value: item.name,
              id: item.id,
            });
          });
        }
      }
      cb(results);
    },
    handleSelect(item) {
      this.searchParams.operator = item.id;
    },
    operatorChange(val) {
      console.log(val, "val");
      if (!val) {
        this.searchParams.operator = "";
      }
    },

    getSearchParamsQueryString() {
      return Object.entries(this.searchParams)
        .filter(([_, value]) => value !== null && value !== undefined && value !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    },
  },
};
</script>

<style lang="scss">
.cell {
  text-align: center !important;
}

.el-table {
  thead {
    tr,
    th {
      background-color: #eee;
    }
  }

  tr,
  th {
    text-align: center !important;
  }
}

.table-section {
  margin-top: 20px;
}

.pagination-section {
  margin-top: 20px;
  text-align: center;
}
</style>
